import { useEffect, useReducer } from "preact/hooks";
import type { GenericSize } from "@brickme/project-core/src/model/geom.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import { doesDeviceHaveTouchCapabilities } from "~/utils/browser.ts";
import ZoomInIcon from "./zoom-in-icon.tsx";
import MouseScrollIcon from "./mouse-scroll-icon.tsx";
import LeftClickMouseIcon from "./left-click-mouse-icon.tsx";
import DragFingerIcon from "./drag-finger-icon.tsx";
import MoveIcon from "./move-icon.tsx";
import PinchIcon from "./pinch-icon.tsx";
import classes from "./choose-layout-overlay.module.css";

type ChooseLayoutOverlayProps = {
	readonly size: GenericSize<number>;
	readonly onClose: () => void;
};

function ChooseLayoutOverlay({ size, onClose }: ChooseLayoutOverlayProps) {
	const t = useTranslator();
	const [closable, allowClose] = useReducer(() => true, false);
	useEffect(() => {
		const timeoutId = setTimeout(() => allowClose(undefined), 3_000);
		return () => clearTimeout(timeoutId);
	}, []);
	return (
		<button
			type="button"
			className={classes["choose-layout-overlay"]}
			style={{
				...size,
				left: `calc(50% - ${size.width / 2}px)`,
				top: `calc(50% - ${size.height / 2}px)`,
			}}
			disabled={!closable}
			onClick={onClose}
		>
			{doesDeviceHaveTouchCapabilities ? (
				<>
					<div className={classes["instruction"]}>
						<div className={classes["icon"]}>
							<PinchIcon />
							<ZoomInIcon />
						</div>
						<div>{t("Pinch to Zoom")}</div>
					</div>
					<div className={classes["instruction"]}>
						<div className={classes["icon"]}>
							<DragFingerIcon />
							<MoveIcon />
						</div>
						<div>{t("Drag to Move")}</div>
					</div>
				</>
			) : (
				<>
					<div className={classes["instruction"]}>
						<div className={classes["icon"]}>
							<MouseScrollIcon />
							<ZoomInIcon />
						</div>
						<div>{t("Scroll to Zoom")}</div>
					</div>
					<div className={classes["instruction"]}>
						<div className={classes["icon"]}>
							<LeftClickMouseIcon />
							<MoveIcon />
						</div>
						<div>{t("Drag to Move")}</div>
					</div>
				</>
			)}
		</button>
	);
}

export default ChooseLayoutOverlay;
